const thirdPartyIntegrations = 'thirdPartyIntegrations';

/** Fetch Actions */
export const FETCH_INTEGRATIONS_ERROR = `${thirdPartyIntegrations}/FETCH_THIRD_PARTY_INTEGRATIONS_ERROR`;
export const FETCH_INTEGRATIONS_REQUEST = `${thirdPartyIntegrations}/FETCH_THIRD_PARTY_INTEGRATIONS_REQUEST`;
export const FETCH_INTEGRATIONS_RESPONSE = `${thirdPartyIntegrations}/FETCH_THIRD_PARTY_INTEGRATIONS_RESPONSE`;

/** Remove Actions */
export const REMOVE_INTEGRATION_ERROR = `${thirdPartyIntegrations}/REMOVE_INTEGRATION_ERROR`;
export const REMOVE_INTEGRATION_REQUEST = `${thirdPartyIntegrations}/REMOVE_INTEGRATION_REQUEST`;
export const REMOVE_INTEGRATION_RESPONSE = `${thirdPartyIntegrations}/REMOVE_INTEGRATION_RESPONSE`;
